import {
    ADDTOCART,
    DECREMENT,
    INCREMENT,
    TOTALITEM,
    TOTALPRICE,
} from "../actions/actions";

const init = {
    products: [
        {
            id: 0,
            title: "Asus Vivobook X515MA",
            qty: 4,
            price: 35500,
        },
        {
            id: 1,
            title: "Dell E1916HV 18.5 Inch",
            qty: 6,
            price: 9300,
        },
        {
            id: 2,
            title: "Asus Vivobook X515MA",
            qty: 8,
            price: 36500,
        },
    ],
    carts: [],
    totalItem: 0,
    totalPrice: 0,
};

const productReducer = (state = init, action) => {
    switch (action.type) {
        case ADDTOCART:
            // copied product
            const localProduct = state.products.map((e) => ({
                ...e,
            }));

            // copied cart
            const localCart = state.carts.map((e) => ({
                ...e,
            }));

            // product index
            const productIndex = localProduct.findIndex(
                (e) => e.id === action.payload.id
            );

            // cart index
            const cartIndex = localCart.findIndex(
                (e) => e.id === action.payload.id
            );

            // checking the object in cart, is exist in cart array
            const isAdded = state.carts.some((e) => e.id === action.payload.id);

            if (!isAdded) {
                const defaultCartQty = { ...action.payload };
                defaultCartQty.qty = 1;

                localProduct[productIndex].qty =
                    localProduct[productIndex].qty - 1;

                return {
                    ...state,
                    products: localProduct,
                    carts: [...state.carts, defaultCartQty],
                };
            } else {
                if (localProduct[productIndex].qty !== 0) {
                    localCart[cartIndex].qty = localCart[cartIndex].qty + 1;

                    localProduct[productIndex].qty =
                        localProduct[productIndex].qty - 1;

                    return {
                        ...state,
                        products: localProduct,
                        carts: localCart,
                    };
                } else {
                    return state;
                }
            }

        case INCREMENT:
            // copied product
            const localProduct2 = state.products.map((e) => ({
                ...e,
            }));

            // copied cart
            const localCart2 = state.carts.map((e) => ({
                ...e,
            }));

            // product index
            const productIndex2 = localProduct2.findIndex(
                (e) => e.id === action.payload
            );

            // cart index
            const cartIndex2 = localCart2.findIndex(
                (e) => e.id === action.payload
            );

            if (localProduct2[productIndex2].qty !== 0) {
                localCart2[cartIndex2].qty = localCart2[cartIndex2].qty + 1;

                localProduct2[productIndex2].qty =
                    localProduct2[productIndex2].qty - 1;
            }

            return {
                ...state,
                carts: localCart2,
                products: localProduct2,
            };

        case DECREMENT:
            // copied product
            const localProduct3 = state.products.map((e) => ({
                ...e,
            }));

            // copied cart
            const localCart3 = state.carts.map((e) => ({
                ...e,
            }));

            // product index
            const productIndex3 = localProduct3.findIndex(
                (e) => e.id === action.payload
            );

            // cart index
            const cartIndex3 = localCart3.findIndex(
                (e) => e.id === action.payload
            );

            if (localCart3[cartIndex3].qty !== 0) {
                localCart3[cartIndex3].qty = localCart3[cartIndex3].qty - 1;

                localProduct3[productIndex3].qty =
                    localProduct3[productIndex3].qty + 1;

                if (localCart3[cartIndex3].qty === 0) {
                    const removeCart = localCart3.filter(
                        (item) => item.id !== action.payload
                    );

                    return {
                        ...state,
                        carts: removeCart,
                        products: localProduct3,
                    };
                }
            }
            return {
                ...state,
                carts: localCart3,
                products: localProduct3,
            };

        case TOTALITEM:
            return {
                ...state,
                totalItem: action.payload,
            };
        case TOTALPRICE:
            return {
                ...state,
                totalPrice: action.payload,
            };
        default:
            return state;
    }
};

export default productReducer;
